import { render, staticRenderFns } from "./wordsList.vue?vue&type=template&id=56efd019"
import script from "./wordsList.vue?vue&type=script&lang=js"
export * from "./wordsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports